import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSettings } from "redux/slices/settings";
const useSettings = () => {
  const settings = useSelector((state) => state.settings.settings);
  const dispatch = useDispatch();
  return {
    // allowAddToCart: false,
    // showTouchPoints: false,
    // dontRequireClientDetailsForPDF: true,
    // filterQuery: "customerName=mlp",
    // customerDisplayName: "MLP",
    // customerLogo: "/assets/imgs/mlp.png",
    ...settings,
    setSettings: (settingsToSet) => {
      console.log("settings", settings);
      console.log("settingsToSet", settingsToSet);
      dispatch(setSettings({ settings: { ...settings, ...settingsToSet } }));
    },
    DEFAULTS: {
      mlp: {
        filterQuery: "customerName=mlp",
        customerDisplayName: "MLP",
        customerLogo: "/assets/imgs/mlp.png",
      },
      "server-builds": {
        filterQuery: null,
        customerDisplayName: "Server Builds",
        customerLogo: "/assets/imgs/od.png",
      },
    },
  };
};

export default useSettings;
